module.exports = __webpack_public_path__ + "static/media/education.8be176ea.webp";